import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LaptopSearch = function LaptopSearch(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : color;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M23 29C18.5875 29 15 25.4125 15 21C15 16.5875 18.5875 13 23 13C27.4125 13 31 16.5875 31 21C31 25.4125 27.4125 29 23 29ZM23 15C19.6875 15 17 17.6875 17 21C17 24.3125 19.6875 27 23 27C26.3125 27 29 24.3125 29 21C29 17.6875 26.3125 15 23 15Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M34.3106 30.8959L28.6538 25.2391L27.2396 26.6533L32.8964 32.3102L34.3106 30.8959Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M45 44H3C1.35 44 0 42.65 0 41V36H48V41C48 42.65 46.65 44 45 44ZM2 38V41C2 41.55 2.45 42 3 42H45C45.55 42 46 41.55 46 41V38H2Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M45 37H43V8C43 7.45 42.55 7 42 7H6C5.45 7 5 7.45 5 8V37H3V8C3 6.35 4.35 5 6 5H42C43.65 5 45 6.35 45 8V37Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M42 40H40V43H42V40Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M38 40H36V43H38V40Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 40H32V43H34V40Z",
      fill: color
    })]
  });
};
export default LaptopSearch;